import { __rest } from 'tslib';
import React from 'react';
import { useTheme, useColor } from '../../theme/Theme.js';
import { useTranslation } from '../../locale/useTranslation.js';
import { Root, CloseIcon } from './styled.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const Tag = React.forwardRef((_a, ref) => {
    var { closable = false, preset = 'default', color, backgroundColor, children, onClose, closeIconTooltip, before, after } = _a, props = __rest(_a, ["closable", "preset", "color", "backgroundColor", "children", "onClose", "closeIconTooltip", "before", "after"]);
    const theme = useTheme();
    const t = useTranslation();
    const [visible, setVisible] = React.useState(true);
    const _color = useColor(color);
    // FIXME: Find a workaround
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const _backgroundColor = useColor(backgroundColor);
    const handleClose = React.useCallback((e) => {
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
    }, [onClose]);
    const tooltipProps = React.useMemo(() => {
        if (!closeIconTooltip)
            return { title: t('general.close') };
        return closeIconTooltip;
    }, [closeIconTooltip, t]);
    if (!visible)
        return null;
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-tag' }, props, { ref: ref, theme: theme, "$color": _color, "$backgroundColor": _backgroundColor, "$preset": preset }),
        before,
        children,
        after,
        closable && (React.createElement(Tooltip, Object.assign({}, tooltipProps),
            React.createElement(CloseIcon, { onClick: handleClose, size: 12 })))));
});
Tag.displayName = 'Tag';

export { Tag };
//# sourceMappingURL=Tag.js.map
